import React, { Component, Fragment } from "react";
import { Link } from "react-router";
import FontAwesome from "./FontAwesome";
import firebase from "firebase";
import Gravatar from "react-gravatar";
import clipboardCopy from "copy-to-clipboard";
import Utils from "../Utils";

import "./AddressList.css";
import Modal from "./Modal";

class AddressList extends Component {
  constructor() {
    super();

    this.state = {
      addresses: [],
      userID: firebase.auth().currentUser.uid,
      firstName: "",
      lastName: "",
      nickname: "",
      email: "",
      password: "",
      cellPhone: "",
      birthday: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      addressID: "",
      isEditing: false,
      isAdding: false,
      scrollY: 0
    };

    this.addressesUpdated = this.addressesUpdated.bind(this);
    this.copyShareLink = this.copyShareLink.bind(this);
    this.firstNameChanged = this.firstNameChanged.bind(this);
    this.lastNameChanged = this.lastNameChanged.bind(this);
    this.nicknameChanged = this.nicknameChanged.bind(this);
    this.emailChanged = this.emailChanged.bind(this);
    this.cellPhoneChanged = this.cellPhoneChanged.bind(this);
    this.birthdayChanged = this.birthdayChanged.bind(this);
    this.address1Changed = this.address1Changed.bind(this);
    this.address2Changed = this.address2Changed.bind(this);
    this.cityChanged = this.cityChanged.bind(this);
    this.stateChanged = this.stateChanged.bind(this);
    this.zipChanged = this.zipChanged.bind(this);
    this.onPlaceChanged = this.onPlaceChanged.bind(this);
    this.addAddress = this.addAddress.bind(this);
    this.updateAddress = this.updateAddress.bind(this);
    this.deleteAddress = this.deleteAddress.bind(this);
    this.clearEditing = this.clearEditing.bind(this);
    this.toggleAddressSelected = this.toggleAddressSelected.bind(this);
    this.showEditAddressModal = this.showEditAddressModal.bind(this);
    this.showAddAddressModal = this.showAddAddressModal.bind(this);
    // this.showConfirmDeleteModal = this.showConfirmDeleteModal.bind(this);
  }

  componentWillMount() {
    firebase
      .database()
      .ref("contacts/" + this.state.userID)
      .on("value", this.addressesUpdated);
  }

  componentWillUnmount() {
    firebase
      .database()
      .ref("contacts/" + this.state.userID)
      .off("value", this.addressesUpdated);
  }

  componentDidMount() {
    window.$("#shareLinkCopy").tooltip({ trigger: "click" });
  }

  addressesUpdated(snapshot) {
    let addresses = [];
    snapshot.forEach(item => {
      let address = item.val();
      address.id = item.key;
      const displayName = `${address.firstName || ""} ${address.lastName ||
        ""}`.trim();
      if (displayName) {
        address.displayName = displayName;
      }
      addresses.push(address);
    });
    this.setState({ addresses });
  }

  showInviteLinkModal() {
    window.$("#invite-link-modal").modal();
  }

  showConfirmDeleteModal() {
    window.$("#delete-address-modal").modal();
  }

  showAddAddressModal() {
    const curScrollY = window.scrollY;
    this.setState({
      firstName: "",
      lastName: "",
      nickname: "",
      email: "",
      password: "",
      cellPhone: "",
      birthday: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      addressID: "",
      isEditing: false,
      isAdding: true,
      scrollY: curScrollY
    });

    window.scrollTo(0, 0);
  }

  highlightShareLink(event) {
    event.target.setSelectionRange(0, event.target.value.length);
  }

  hideClipboardTooltip(event) {
    window.$(event.target).tooltip("hide");
  }

  copyShareLink(event) {
    clipboardCopy(
      `${location.protocol}//${location.host}/new/${this.state.userID}`
    );
    // window.$(event.target).tooltip('show');
  }

  onPlaceChanged() {
    if (!this.autocomplete) return;
    console.log("autocomplete", this.autocomplete);
    const place = this.autocomplete.getPlace();
    console.log("place", place);
    if (place.address_components) {
      // Hacked together from: https://github.com/alanrsoares/react-address-lookup/blob/master/AddressLookup.js
      // TODO: Clean this up!
      const camelize = s => s.replace(/_./g, ([_, x]) => x.toUpperCase());
      const camelizeKeys = o =>
        Object.keys(o).reduce(
          (acc, k) => ({ ...acc, [camelize(k)]: o[k] }),
          {}
        );
      const type = ({ types }) => types[0];
      const reducer = (acc, component, i) => ({
        ...acc,
        [camelize(type(component))]: camelizeKeys(component)
      });
      const result = place.address_components.reduce(reducer, {});
      // console.log(result);
      const {
        streetNumber: number,
        route: street,
        locality: city,
        administrativeAreaLevel1: state,
        postalCode: zip
      } = result;
      // console.log(place.address_components);
      //const [{long_name : number}, {long_name : street}, {long_name : city}, {long_name : county}, {short_name : state}, {long_name : country}, {long_name : zip}] = place.address_components;
      // console.log(number,street,city,state,zip);
      this.setState({
        address1: `${number.longName} ${street.longName}`,
        city: city.longName,
        state: state.shortName,
        zip: zip.longName
      });
    }
  }

  firstNameChanged(event) {
    this.setState({ firstName: event.target.value });
  }

  lastNameChanged(event) {
    this.setState({ lastName: event.target.value });
  }

  nicknameChanged(event) {
    this.setState({ nickname: event.target.value });
  }

  emailChanged(event) {
    this.setState({ email: event.target.value });
  }

  cellPhoneChanged(event) {
    this.setState({ cellPhone: event.target.value });
  }

  birthdayChanged(event) {
    this.setState({ birthday: event.target.value });
  }

  address1Changed(event) {
    event.preventDefault();
    this.setState({ address1: event.target.value });
  }

  address2Changed(event) {
    this.setState({ address2: event.target.value });
  }

  cityChanged(event) {
    this.setState({ city: event.target.value });
  }

  stateChanged(event) {
    if (event.target.value) {
      this.setState({ state: event.target.value });
    }
  }

  zipChanged(event) {
    this.setState({ zip: event.target.value });
  }

  addAddress() {
    const newAddress = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      nickname: this.state.nickname,
      email: this.state.email,
      cellPhone: this.state.cellPhone.replace(/\D/g, ""),
      birthday: this.state.birthday,
      address1: this.state.address1,
      address2: this.state.address2,
      city: this.state.city,
      state: this.state.state,
      zip: this.state.zip
    };

    if (newAddress.firstName && newAddress.lastName) {
      firebase
        .database()
        .ref("contacts/" + this.state.userID)
        .push(newAddress)
        .then(
          contact => {
            this.clearEditing();
            // Scroll to the new item
            window.setTimeout(() => {
              document
                .querySelector(`#${contact.key}`)
                .scrollIntoView({ behavior: "smooth" });
            }, 100);
          },
          err => {
            console.error(err);
          }
        );
    }
  }

  toggleAddressSelected(id) {
    const address = this.state.addresses.find(address => address.id === id);
    address.selected = !!!address.selected;
    this.setState({ addresses: this.state.addresses });
  }

  showEditAddressModal(address) {
    const curScrollY = window.scrollY;
    this.setState({
      firstName: address.firstName,
      lastName: address.lastName,
      nickname: address.nickname,
      email: address.email,
      password: address.password,
      cellPhone: address.cellPhone,
      birthday: address.birthday,
      address1: address.address1,
      address2: address.address2,
      city: address.city,
      state: address.state,
      zip: address.zip,
      isEditing: true,
      addressID: address.id,
      scrollY: curScrollY
    });

    window.scrollTo(0, 0);
  }

  clearEditing() {
    const prevScrollY = this.state.scrollY;
    this.setState({
      firstName: "",
      lastName: "",
      nickname: "",
      email: "",
      password: "",
      cellPhone: "",
      birthday: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      addressID: "",
      isEditing: false,
      isAdding: false,
      scrollY: 0
    });
    delete this.addressInput;
    delete this.autocomplete;
    window.setTimeout(() => {
      window.scrollTo(0, prevScrollY);
    }, 100);
  }

  updateAddress() {
    const newAddress = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      nickname: this.state.nickname || "",
      email: this.state.email || "",
      cellPhone: this.state.cellPhone.replace(/\D/g, "") || "",
      birthday: this.state.birthday || "",
      address1: this.state.address1 || "",
      address2: this.state.address2 || "",
      city: this.state.city || "",
      state: this.state.state || "",
      zip: this.state.zip || ""
    };

    if (newAddress.firstName && newAddress.lastName) {
      firebase
        .database()
        .ref(`contacts/${this.state.userID}/${this.state.addressID}`)
        .set(newAddress)
        .then(
          contact => {
            this.clearEditing();
          },
          err => {
            console.error(err);
          }
        );
    }
  }

  deleteAddress() {
    const newAddress = {
      firstName: this.state.firstName || "",
      lastName: this.state.lastName || "",
      nickname: this.state.nickname || "",
      email: this.state.email || "",
      cellPhone: this.state.cellPhone.replace(/\D/g, "") || "",
      birthday: this.state.birthday || "",
      address1: this.state.address1 || "",
      address2: this.state.address2 || "",
      city: this.state.city || "",
      state: this.state.state || "",
      zip: this.state.zip || ""
    };

    if (newAddress.firstName && newAddress.lastName) {
      firebase
        .database()
        .ref(`/deleted/contacts/${this.state.userID}/${this.state.addressID}`)
        .set(newAddress)
        .then(
          contact => {
            firebase
              .database()
              .ref(`/contacts/${this.state.userID}/${this.state.addressID}`)
              .remove()
              .then(
                () => {
                  this.clearEditing();
                },
                err => {
                  console.error(err);
                }
              );
          },
          err => {
            console.error(err);
          }
        );
    }
  }

  render() {
    const addressRows = [];
    let prevLetter = "";
    for (let address of this.state.addresses.sort(
      Utils.sortBy("lastName", "firstName")
    )) {
      if (
        address.lastName &&
        prevLetter !== address.lastName.toUpperCase().charAt(0)
      ) {
        prevLetter = address.lastName.toUpperCase().charAt(0);
        addressRows.push(
          <li key={prevLetter} className="list-group-item letter-divider">
            {prevLetter}
          </li>
        );
      }
      addressRows.push(
        <li
          key={address.id}
          id={address.id}
          className="address-listing list-group-item list-group-item-action"
          onClick={() => this.showEditAddressModal(address)}
        >
          <div className="image">
            <Gravatar
              className="gravatar"
              email={address.email}
              size={48}
              default={
                address.displayName
                  ? `https://ui-avatars.com/api/${address.displayName.replace(
                      " ",
                      "+"
                    )}/48/2f2f51/ffffff`
                  : "https://ui-avatars.com/api/-/48/2f2f51/ffffff"
              }
            />
            {/* <img
              className="gravatar"
              src={`https://ui-avatars.com/api/${
                address.displayName ? address.displayName.replace(" ", "+") : ""
              }/128/344950/ffffff`}
            /> */}
          </div>
          <div className="listing">
            <h4 className="name">{address.displayName || " "}</h4>
            <div className="nickname">
              {address.nickname && address.nickname !== address.displayName
                ? address.nickname
                : " "}
            </div>
            {/*<div className="cellphone">{address.cellPhone ? Utils.formatPhone(address.cellPhone) : ' '}</div>*/}
            <div className="address">
              <div className="address-line1">{address.address1 || " "}</div>
              <div className="address-line2">{address.address2 || " "}</div>
            </div>
            <span className="city">{address.city}</span>
            {address.city && address.state ? (
              <span className="d-md-none">, </span>
            ) : (
              ""
            )}{" "}
            <span className="state">{address.state}</span>{" "}
            <span className="zip">{address.zip}</span>
          </div>
        </li>
      );
    }

    let rowCount = "";
    if (this.state.addresses.length === 1) {
      rowCount = "You have 1 contact.";
    } else {
      rowCount = `You have ${this.state.addresses.length} contacts.`;
    }

    const addressListView = (
      <section id="address-list-view" className="card">
        <div className="card-body">
          <h2 className="card-title">Address List</h2>
          <div className="subhead-toolbar">
            <h3 className="card-subtitle mb-2 text-muted">{rowCount}</h3>
            <div className="toolbar">
              <button
                className="btn btn-fab btn-primary"
                onClick={this.showAddAddressModal}
              >
                <FontAwesome name="plus" />{" "}
                <span className="sr-only d-md-block">Add Address</span>
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={this.showInviteLinkModal}
              >
                <FontAwesome type="thin" name="link" /> Get Share Link
              </button>
              <Link
                to="/labels"
                className="btn btn-outline-primary d-none d-md-block"
              >
                <FontAwesome type="thin" name="address-card" /> View as Labels
              </Link>
            </div>
          </div>
          <ul id="address-list" className="list-group">
            {addressRows}
          </ul>
          <Modal
            name="invite-link-modal"
            title="Share your contact collection link"
          >
            <p>
              In order to start collecting contact information from others, just
              send them the following link.
            </p>
            <p>
              <strong>Note:</strong>
              &nbsp;Your first and last name will be shared with anyone that has
              this link.
            </p>
            <div className="input-group">
              <input
                id="shareLink"
                type="url"
                className="form-control"
                placeholder="Your custom address book link"
                value={`${location.protocol}//${location.host}/new/${this.state.userID}`}
                readOnly
                onClick={this.highlightShareLink}
              />
              <div
                id="shareLinkCopy"
                className="input-group-append pointer"
                data-toggle="tooltip"
                title="Copied to clipboard!"
                onClick={this.copyShareLink}
                onMouseLeave={this.hideClipboardTooltip}
              >
                <span className="input-group-text">
                  <FontAwesome type="solid" name="clipboard" />
                </span>
              </div>
            </div>
          </Modal>
        </div>
      </section>
    );
    const editAddressView = (
      <section id="address-list-view" className="card">
        <div className="card-body">
          <h2 className="card-title">
            {this.state.isEditing ? "Edit Address" : "Add an Address"}
          </h2>
          {/*<h3 className="card-subtitle mb-2 text-muted">{this.state.firstName} {this.state.lastName}</h3>*/}
          <form
            ref="addAddressForm"
            onSubmit={
              this.state.isEditing ? this.updateAddress : this.addAddress
            }
          >
            <div className="sm-flex-col md-flex-row">
              <div className="form-group">
                <label
                  htmlFor="add-new-address-first-name"
                  className="required"
                >
                  First Name
                </label>
                <input
                  id="add-new-address-first-name"
                  type="text"
                  className="form-control"
                  placeholder="First Name"
                  required="required"
                  value={this.state.firstName}
                  onChange={this.firstNameChanged}
                  pattern="."
                />
              </div>
              <div className="form-group">
                <label htmlFor="add-new-address-last-name" className="required">
                  Last Name
                </label>
                <input
                  id="add-new-address-last-name"
                  type="text"
                  className="form-control"
                  placeholder="Last Name"
                  required
                  value={this.state.lastName}
                  onChange={this.lastNameChanged}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="add-new-address-nickname">Nickname</label>
              <input
                id="add-new-address-nickname"
                type="text"
                className="form-control"
                placeholder="e.g., The Lashkari Family"
                value={this.state.nickname}
                onChange={this.nicknameChanged}
              />
            </div>
            <div className="form-group">
              <label htmlFor="add-new-address-email">Email</label>
              {/* TODO: convert this to a component */}
              <input
                id="add-new-address-email"
                type="text"
                className="form-control"
                placeholder="Email"
                value={this.state.email}
                onChange={this.emailChanged}
              />
            </div>
            <div className="sm-flex-col md-flex-row">
              <div className="form-group">
                <label htmlFor="add-new-address-cell-phone">Cell Phone</label>
                {/* TODO: convert this to a component */}
                <input
                  id="add-new-address-cell-phone"
                  type="text"
                  className="form-control"
                  placeholder="Cell Phone"
                  value={this.state.cellPhone}
                  onChange={this.cellPhoneChanged}
                />
              </div>
              <div className="form-group">
                <label htmlFor="add-new-address-birthday">Birthday</label>
                {/* TODO: convert this to a component */}
                <input
                  id="add-new-address-birthday"
                  type="date"
                  className="form-control"
                  placeholder="MM/DD/YYYY"
                  value={this.state.birthday}
                  onChange={this.birthdayChanged}
                />
              </div>
            </div>
            <div className="form-group">
              {/* TODO: use address validation API to fill in the rest? */}
              <label htmlFor="add-new-address-address1">Street Address</label>
              <input
                id="add-new-address-address1"
                ref={addressInput => {
                  if (!this.addressInput && addressInput) {
                    this.addressInput = addressInput;
                    this.autocomplete = new window.google.maps.places.Autocomplete(
                      addressInput,
                      {
                        types: ["address"]
                      }
                    );

                    this.autocomplete.addListener(
                      "place_changed",
                      this.onPlaceChanged
                    );
                  }
                }}
                type="text"
                autoComplete="nope"
                className="form-control"
                placeholder="Street Address"
                value={this.state.address1}
                onChange={this.address1Changed}
              />
            </div>
            <div className="form-group">
              <label htmlFor="add-new-address-address2">Address Line 2</label>
              <input
                id="add-new-address-address2"
                type="text"
                className="form-control"
                placeholder="e.g., Apartment #105"
                value={this.state.address2}
                onChange={this.address2Changed}
              />
            </div>
            <div className="sm-flex-col md-flex-row">
              <div className="form-group">
                <label htmlFor="add-new-address-city">City</label>
                <input
                  id="add-new-address-city"
                  type="text"
                  className="form-control"
                  placeholder="City"
                  value={this.state.city}
                  onChange={this.cityChanged}
                />
              </div>
              <div className="form-group">
                <label htmlFor="add-new-address-state">State</label>
                {/* TODO: convert this to a component */}
                <select
                  id="add-new-address-state"
                  className="form-control"
                  value={this.state.state}
                  onChange={this.stateChanged}
                >
                  <option value="" disabled>
                    Select your state...
                  </option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AS">American Samoa</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FM">Federated States Of Micronesia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="GU">Guam</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MH">Marshall Islands</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="MP">Northern Mariana Islands</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PW">Palau</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="PR">Puerto Rico</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VI">Virgin Islands</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="add-new-address-zip">ZIP Code</label>
                <input
                  id="add-new-address-zip"
                  type="text"
                  className="form-control"
                  placeholder="ZIP Code"
                  value={this.state.zip}
                  onChange={this.zipChanged}
                />
              </div>
            </div>
          </form>
          <div className="footer-toolbar">
            <div className="toolbar">
              {this.state.isEditing ? (
                <button
                  type="button"
                  className="btn btn-danger ml-0 mr-auto"
                  onClick={this.showConfirmDeleteModal}
                >
                  Delete
                </button>
              ) : (
                ""
              )}
              <button
                type="button"
                className="btn btn-secondary ml-auto"
                onClick={this.clearEditing}
              >
                Cancel
              </button>
              <button
                type="submit"
                className={`btn btn-primary ${
                  this.state.firstName && this.state.lastName ? "" : "disabled"
                }`.trim()}
                disabled={
                  this.state.firstName && this.state.lastName ? "" : "disabled"
                }
                onClick={
                  this.state.isEditing ? this.updateAddress : this.addAddress
                }
              >
                {this.state.isEditing ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </div>
        {this.state.isEditing ? (
          <Modal
            name="delete-address-modal"
            type="danger"
            title="Delete Address"
            buttons={[
              <button
                key="cancel"
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={this.clearEditing}
              >
                Cancel
              </button>,
              <button
                key="delete"
                type="button"
                className="btn btn-danger"
                data-dismiss="modal"
                onClick={this.deleteAddress}
              >
                Delete
              </button>
            ]}
          >
            <p>
              Are you sure you want to delete{" "}
              <strong>
                {this.state.firstName} {this.state.lastName}
              </strong>{" "}
              from your address book?
            </p>
            <p>
              <strong>Note:</strong> You cannot undo this action.
            </p>
          </Modal>
        ) : (
          ""
        )}
      </section>
    );
    let curView;
    if (this.state.isEditing || this.state.isAdding) {
      curView = editAddressView;
    } else {
      curView = addressListView;
    }
    return <Fragment>{curView}</Fragment>;
  }
}

export default AddressList;



// WEBPACK FOOTER //
// ./src/components/AddressList.js